var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-cd07674c-0d47-456a-96a6-095744fa6da2",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 949.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-fb1e5860-eff6-41b9-a9fa-707003e01821",
    d: "M1043.67,423.1L85.05,5.21C62.22-4.81,35.67-.24,17.8,17.74-.08,35.62-4.93,62.06,5.26,85.09l108.01,243.45c13.61,30.69,41.49,52.68,74.51,58.78l395.88,73.1c16.03,2.96,16.03,25.94,0,28.9l-394.22,72.79c-33.11,6.11-61.05,28.21-74.62,59.02L7.41,864.98c-9.91,22.94-4.96,49.27,12.73,66.96,11.65,11.67,27.02,17.79,42.66,17.79,8.07,0,16.22-1.65,23.99-5.06l956.47-410.49c22.17-9.53,36.65-31.2,36.74-55.3.11-24.19-14.19-46.06-36.33-55.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatArrow);
export default __webpack_public_path__ + "static/media/ChatArrow.63d7e09ed2713d529a335e1900af72c2.svg";
export { ForwardRef as ReactComponent };